import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { AdminAsideMenuList } from "./AdminAsideMenuList";
import { menu, filterMenuByAccountLevel } from "../../../../../app/Menu";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import AuthService from "../../../../../app/base/services/authentication.service";
import { UserRolesEnum } from "../../../../../app/pages/auth/userRoles.enum";
import { LocalStorageService } from "../../../../../app/base/services/local-storage.service";

// Top-level account/billing pages that live outside any workspace. On these the
// admin menu must show regardless of whether a workspace/project is still selected
// in localStorage, so navigating here (e.g. "Add funds") doesn't require wiping
// the workspace context — which would 401 the user when they go back.
const TOP_LEVEL_PATHS = [
   "/balance",
   "/usage",
   "/subscription-plans",
   "/profile",
   "/login-information"
];

export function AdminAsideMenu({ disableScroll, isMinimized }) {
   const uiService = useHtmlClassService();
   // Re-render on navigation so the menu choice below is re-evaluated when moving
   // between pages within the same layout (e.g. to /balance).
   const { pathname } = useLocation();
   const isTopLevelPage = TOP_LEVEL_PATHS.includes(pathname);
   const layoutProps = useMemo(() => {
      return {
         layoutConfig: uiService.config,
         asideMenuAttr: uiService.getAttributes("aside_menu"),
         ulClasses: uiService.getClasses("aside_menu_nav", true),
         asideClassesFromConfig: uiService.getClasses("aside_menu", true)
      };
   }, [uiService]);

   return (
      <>
         {/* begin::Menu Container */}
         <div
            id="kt_aside_menu"
            data-menu-vertical="1"
            className={`aside-menu aside-menu-left my-4 ${layoutProps.asideClassesFromConfig}`}
            {...layoutProps.asideMenuAttr}
         >
            {AuthService.isAuthorized([
               UserRolesEnum.SuperAdmin,
               UserRolesEnum.Organization,
               UserRolesEnum.AdminOfOrganization,
               UserRolesEnum.SeniorProjectManager,
               UserRolesEnum.JuniorProjectManager,
               UserRolesEnum.ProjectManager
            ]) &&
            (isTopLevelPage ||
               !LocalStorageService.getItem("currentWorkspaceId") ||
               !LocalStorageService.getItem("currentProjectID")) ? (
               <AdminAsideMenuList
                  data={filterMenuByAccountLevel(menu.adminLayout)}
                  layoutProps={layoutProps}
                  isMinimized={isMinimized}
               />
            ) : (
               <AdminAsideMenuList
                  data={filterMenuByAccountLevel(menu.layout)}
                  layoutProps={layoutProps}
                  isMinimized={isMinimized}
               />
            )}
         </div>
         {/* end::Menu Container */}
      </>
   );
}
